import './DrumForFun.css'
import React, { useState } from 'react'
import Drumpad from './Drumpad'
import Dsc_Oh from '../../assets/sounds/Dsc_Oh.mp3'
import Heater_6 from '../../assets/sounds/Heater-6.mp3'
import Heater4_1 from '../../assets/sounds/Heater-4_1.mp3'
import Dry_Ohh from '../../assets/sounds/Dry_Ohh.mp3'
import Give_us_a_light from '../../assets/sounds/Give_us_a_light.mp3'
import Bld_H1 from '../../assets/sounds/Bld_H1.mp3'
import punchy_kick_1 from '../../assets/sounds/punchy_kick_1.mp3'
import Brk_Snr from '../../assets/sounds/Brk_Snr.mp3'
import RP4_KICK_1 from '../../assets/sounds/RP4_KICK_1.mp3'

const drumset = [
  { key: 81, id: 'Q', label: 'Open H.H.', url: Dsc_Oh },
  { key: 87, id: 'W', label: 'Clap', url: Heater_6 },
  { key: 69, id: 'E', label: 'Heater', url: Heater4_1 },
  { key: 65, id: 'A', label: 'Dumpped H.H.', url: Dry_Ohh },
  { key: 83, id: 'S', label: 'Shaker', url: Give_us_a_light },
  { key: 68, id: 'D', label: 'Dumpped C.H.H.', url: Bld_H1 },
  { key: 90, id: 'Z', label: 'Punchy Kick', url: punchy_kick_1 },
  { key: 88, id: 'X', label: 'Snare', url: Brk_Snr },
  { key: 67, id: 'C', label: 'Kick', url: RP4_KICK_1 },
]

const DrumForFun = props => {
  const [display, setDisplay] = useState(undefined)

  return (
    <div className='drumforfun-container'>
      <div className='drumforfun-metal drumforfun-linear' id='drum-machine'>
        <div id='drumforfun-display'>
          <div className='drumforfun-text'>{display}</div>
        </div>
        <div id='drumforfun-drumset'>
          {drumset.map(p => (
            <Drumpad soundset={p} display={setDisplay} key={p.id} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default DrumForFun